import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";

function AdminLogin() {
  const [form, setForm] = useState({
    username: "",
    password: "",
  });

  const navigate = useNavigate(); // ✅ important

  const handleLogin = () => {
    if (
      form.username === "adminbiome" &&
      form.password === "@#Biome26"
    ) {
      localStorage.setItem("admin_auth", "true");

      toast.success("Login successful ✅");

      // ✅ redirect using router
      setTimeout(() => {
        navigate("/admin/biome-dashboard");
      }, 800);
    } else {
      toast.error("Invalid credentials ❌");
    }
  };

  return (
    <div className="biome biome-24">
       <div className="biome-element biome-element-47b1a33 e-con-full e-flex e-con e-child biome-card-sticky biome-card-sticky-top ">
         <div className="e-con-inner text_center attr-text-white  section-scroll-animation">
            

            <div className="biome-login">
                <h1 className="biome-heading-title biome-size-default animation__char_come  gsap-text  attr-text-white">Admin Login</h1>
                <input
        type="text"
        placeholder="Username"
        onChange={(e) =>
          setForm({ ...form, username: e.target.value })
        }
      />


      <input
        type="password"
        placeholder="Password"
        onChange={(e) =>
          setForm({ ...form, password: e.target.value })
        }
      />


      <button onClick={handleLogin}>Login</button>
            </div>
        </div>
       </div>
    </div>
  );
}

export default AdminLogin;